import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ajustesRoutes } from './features/ajustes/ajustes.routes';
import { analiticaRoutes } from './features/analitica/analitica.routes';
import { ayudaRoutes } from './features/ayuda/ayuda.routes';
import { gestionComercialRoutes } from './features/gestion-comercial/gestion-comercial.routes';
import { ordenesRoutes } from './features/ordenes/ordenes.routes';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth/callback/callback.component').then((m) => m.CallbackComponent),
  },
  {
    path: 'auth/error-login',
    loadComponent: () =>
      import('./features/auth/error-login/error-login.page').then((m) => m.ErrorLoginPage),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/shells/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./features/auth/redirect/initial-route-redirect.component').then(
            (m) => m.InitialRouteRedirectComponent,
          ),
      },
      {
        path: 'sin-acceso',
        loadComponent: () => import('./features/auth/no-access/no-access.page').then((m) => m.NoAccessPage),
      },
      ...ordenesRoutes,
      ...gestionComercialRoutes,
      ...analiticaRoutes,
      ...ajustesRoutes,
      ...ayudaRoutes,
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
